import $ from 'jquery';
import 'slick-carousel';

export default () => {

  /**
   * set mainvisual slider
   */
  const setMainVisualSlider = () => {
    const mainVisualSliderElements = document.querySelectorAll('.mainVisual__slider');
    if (mainVisualSliderElements.length) {
      mainVisualSliderElements.forEach(mainVisualSliderElement => {
        const sliderItems = mainVisualSliderElement.children;
        let currentIndex = 0;
        sliderItems[0].classList.add('is-active');
        const sliderAnimationTimer = setInterval(() => {
          currentIndex++;
          if (currentIndex == sliderItems.length) {
            currentIndex = 0;
          }
          Array.prototype.forEach.call(sliderItems, (sliderItem: HTMLElement) => {
            sliderItem.classList.remove('is-active');
          });
          sliderItems[currentIndex].classList.add('is-active');
        }, 2000);
      });
    }
  }
  
  window.addEventListener('DOMContentLoaded', () => { //htmlが読み込ませた後に実行する

    setMainVisualSlider();

    /**
    * header dropdown
    */
    const btn = document.querySelector('.l-navi__page--about'); // ボタンをidで取得
    if(btn) { // ボタンが存在しないときにエラーになるのを回避
      btn.addEventListener('click', function(){ //ボタンがクリックされたら
        this.classList.toggle('is-open'); // is-openを付加する
      });
    }

  });

  $(() => {
    // jQuery Code Here

    /**
     * Slick Carousel
     */
    $(window).on('load resize orientationchange', function () {
      // sp
      if ($(window).width() < 640) {
        $('.js-slick-ecoball-1, .js-slick-ecoball-2').not('.slick-initialized').slick({dots: true});
        $('.js-slick-ecoball-navi').not('.slick-initialized').slick();
      } else {
        // pc
        $('.js-slick-ecoball-1, .js-slick-ecoball-2, .js-slick-ecoball-navi.slick-initialized').slick('unslick');
      }
    });



  });
}
